import React, {useState} from 'react';
import {Button, Dialog, DialogContent, TextField, Tooltip, IconButton} from '@mui/material';
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from '@mui/icons-material/Close';
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";
import axios from "axios";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";

function CaseMergeDecline({open, onClose, onDeny, users, closeModal, caseData}) {
    const urlParams = new URLSearchParams(window.location.search);
    const caseId = urlParams.get('id');
    const [declinationReason, setDeclinationReason] = useState("");
    const [isDenyModalOpen, setIsDenyModalOpen] = useState(false);

    const denyToMoveCase = async () => {
        const expert = users.find(user => user.id === caseData.requesttomovetoobjectregistrybyexpertDenide);
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const caseNotification = {
            nextStepUserId: expert ? expert.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.denyToMoveCaseToObjectRegistery.id,
            caseStatus: 8,
            viewed: false,
            declinationReason: declinationReason
        };

        try {
            const payload = {
                caseId: caseId,
                requesttomovetoobjectregistrybyexpert: false,
                requesttomovetoobjectregistrybyexpertDenide: declinationReason,
                answerOfHeadOfDepartment: false
            };
            try {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateRequesttomovetoobjectregistrybyexpert`, payload);
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
                onDeny()
                closeModal()
                setIsDenyModalOpen(false)
            } catch (error) {
                console.error('Error merging cases:', error);
            }

        } catch (error) {
        }
    };

    return (
        <div>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="md"
                fullWidth
            >
                <div style={{position: 'relative'}}>
                    {/* Close button on the top-right */}
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        style={{position: 'absolute', right: 8, top: 8}}
                    >
                        <CloseIcon/>
                    </IconButton>
                </div>

                <DialogContent>
                    <TextField
                        style={{marginTop: 30}}
                        value={declinationReason}
                        onChange={(e) => setDeclinationReason(e.target.value)}
                        label="დახარვეზების მიზეზი"
                        multiline
                        fullWidth
                        rows={4}
                    />
                    <div style={{display: 'flex', justifyContent: 'center', marginTop: '20px'}}>
                        <Tooltip title={declinationReason === "" ? "შეიყვანეთ დახარვეზების მიზეზი" : ""}>
                            <span style={{cursor: declinationReason === "" ? "not-allowed" : "pointer"}}>
                                <Button
                                    variant="contained"
                                    color="error"
                                    disabled={declinationReason === ""}
                                    onClick={() => setIsDenyModalOpen(true)}
                                    style={{margin: '10px 0', width: '400px'}}
                                    endIcon={<CancelIcon/>}
                                >
                                    გადატანაზე უარის თქმა
                                </Button>
                            </span>
                        </Tooltip>
                    </div>
                </DialogContent>
                <ConfirmationModal
                    isOpen={isDenyModalOpen}
                    onRequestClose={() => setIsDenyModalOpen(false)}
                    onConfirm={denyToMoveCase}
                />
            </Dialog>
        </div>
    );
}

export default CaseMergeDecline;
